import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button, Typography } from '@bolteu/clay-react';
import { logoutAsync } from '@bolteu/redux-session';

import { $tk } from 'utils/appTranslationKey';

import illustrationSrc from './assets/man-with-laptop.png';

const pageTk = $tk.screens.AccountMisconfigured;

export function AccountMisconfiguredPage() {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const handleSignOut = () => {
    dispatch(logoutAsync.request({ shouldResetToken: true }));
  };

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-6 px-6">
      <img src={illustrationSrc} alt="" className="size-37" />
      <div className="flex flex-col items-center gap-2">
        <Typography defaultTag="h1" className="bolt-font-body-l-accent text-center">
          {formatMessage({ id: pageTk.title })}
        </Typography>
        <Typography className="text-secondary text-center">
          {formatMessage({ id: pageTk.text })}
        </Typography>
        <Button onClick={handleSignOut}>{formatMessage({ id: pageTk.signOutButton })}</Button>
      </div>
    </div>
  );
}
